/**
 * A default set of media queries to use for different screen sizes. Based on
 * the breakpoints from purecss.
 *
 * Use like:
 *   StyleSheet.create({
 *       blah: {
 *           [mediaQueries.xs]: {
 *
 *           },
 *       },
 *   });
 */

// sync-start:media-queries 1539339461 typings/aphrodite.d.ts
// sync-start:media-queries 1539339461 apps/assessments/typings/aphrodite.d.ts
export const pureSmMin = "568px";
export const pureMdMin = "768px";
export const pureLgMin = "1024px";
export const pureXlMin = "1200px";
export const pureXsMax = "567px";
export const pureSmMax = "767px";
export const pureMdMax = "1023px";
export const pureLgMax = "1199px";

// HACK(mdr): Attach an inline comment to each media query to make it unique.
//
// Aphrodite accepts an object that maps keys (like media queries) to values
// (like the set of rules that we should apply under that media query). But the
// keys of a JS object are, by definition, unique. So, if we compute two media
// queries dynamically, and they happen to evaluate to the same string, they'll
// conflict. JS resolves key conflicts in object literals by discarding all but
// the last key-value pair, so some rules are thrown out before Aphrodite even
// gets the chance to see them - which means that those rules will never be
// applied! D: (This happened in the content library's FloatingSidebar.)
//
// We _could_ solve this problem by building a higher-level API to help us
// merge those two rule sets before passing them to Aphrodite. That'd be pretty
// sweet, but also nontrivial, so we're not going to do that right now.
//
// Instead, we just attach a unique comment string to each of the media queries
// in this file. That way, if another media query has the same constraints as
// one of these queries, their strings won't be identical, and they therefore
// won't conflict.
//
// It's legal to put inline comments just about anywhere in CSS, so just about
// any CSS parser should be satisfied - but we tested in all major supported
// browsers, just to be sure :)
export const mediaQueries = {
    xs: `@media screen and (max-width: ${pureXsMax}) /* mediaQueries.xs */`,
    sm: `@media screen and (min-width: ${pureSmMin}) and (max-width: ${pureSmMax}) /* mediaQueries.sm */`,
    md: `@media screen and (min-width: ${pureMdMin}) and (max-width: ${pureMdMax}) /* mediaQueries.md */`,
    lg: `@media screen and (min-width: ${pureLgMin}) and (max-width: ${pureLgMax}) /* mediaQueries.lg */`,
    xl: `@media screen and (min-width: ${pureXlMin}) /* mediaQueries.xl */`,

    xsOrSmaller: `@media screen and (max-width: ${pureXsMax}) /* mediaQueries.xsOrSmaller */`,
    smOrSmaller: `@media screen and (max-width: ${pureSmMax}) /* mediaQueries.smOrSmaller */`,
    mdOrSmaller: `@media screen and (max-width: ${pureMdMax}) /* mediaQueries.mdOrSmaller */`,
    lgOrSmaller: `@media screen and (max-width: ${pureLgMax}) /* mediaQueries.lgOrSmaller */`,

    smOrLarger: `@media screen and (min-width: ${pureSmMin}) /* mediaQueries.smOrLarger */`,
    mdOrLarger: `@media screen and (min-width: ${pureMdMin}) /* mediaQueries.mdOrLarger */`,
    lgOrLarger: `@media screen and (min-width: ${pureLgMin}) /* mediaQueries.lgOrLarger */`,
    xlOrLarger: `@media screen and (min-width: ${pureXlMin}) /* mediaQueries.xlOrLarger */`,
} as const;
// sync-end:media-queries
